var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.973C14.3159 27.5074 12.7549 25.9006 11.3333 24.1695C9.19996 21.5699 6.66663 17.6983 6.66663 14.009C6.6657 12.1249 7.21264 10.2828 8.23822 8.71589C9.2638 7.14901 10.7219 5.92775 12.4281 5.20667C14.1342 4.4856 16.0116 4.29713 17.8228 4.66511C19.6339 5.03309 21.2974 5.94098 22.6026 7.27388C23.4716 8.15656 24.1604 9.20632 24.6291 10.3624C25.0979 11.5185 25.3372 12.7579 25.3333 14.009C25.3333 17.6983 22.8 21.5699 20.6666 24.1695C19.245 25.9006 17.684 27.5073 16 28.973ZM16 9.92794C14.9391 9.92794 13.9217 10.3579 13.1715 11.1233C12.4214 11.8886 12 12.9266 12 14.009C12 15.0914 12.4214 16.1294 13.1715 16.8948C13.9217 17.6601 14.9391 18.0901 16 18.0901C17.0608 18.0901 18.0782 17.6601 18.8284 16.8948C19.5785 16.1294 20 15.0914 20 14.009C20 12.9266 19.5785 11.8886 18.8284 11.1233C18.0782 10.3579 17.0608 9.92794 16 9.92794Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6b5457f0b88286639415c443bae97135.svg";
export { ForwardRef as ReactComponent };